import React, { ReactElement } from "react";
import { useParams } from "react-router-dom";
import CompetitorProductDbOverview from "./CompetitorProduct/CompetitorProductDbOverview";
import PrototypeDbOverview from "./Prototype/PrototypeDbOverview";
import UnknownProductDbOverview from "./UnknownProduct/UnknownProductDbOverview";

const ProductsPage = (): React.ReactElement => {
  // @ts-ignore
  const { productType } = useParams();

  switch (productType) {
    case "prototype":
      return <PrototypeDbOverview />;

    case "unknown":
      return <UnknownProductDbOverview />;

    case "competitor":
      return <CompetitorProductDbOverview />;

    default:
      // TODO add "page not found"
      return <></>;
  }
};

export default ProductsPage;
